import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { prepareSearchParams } from '@/libs/helper';

const resource = `${Config.basePath}/queue`;

export default {
  get(payload) {
    return Client.get(`${resource}/count/${payload.merchantId}`);
  }
};
